export const iconFontAwesomeHumanitarianPersonBreastfeeding = (
	<i className="fa-solid fa-person-breastfeeding"></i>
);
